import * as Sentry from '@sentry/react-router';
import type { ZodError } from 'zod';

function summarizePayload(payload: unknown) {
  if (payload == null || typeof payload !== 'object') {
    return { type: typeof payload };
  }

  const record = payload as Record<string, unknown>;

  return {
    type: 'object',
    id: record.id,
    status: record.status,
    keys: Object.keys(record).slice(0, 25),
    itemCount: Array.isArray(record.items) ? record.items.length : undefined,
    fulfillmentCount: Array.isArray(record.fulfillments) ? record.fulfillments.length : undefined,
    hasPatient: record.patient != null,
    hasInsurance: record.insurance != null,
  };
}

export function reportOrderTransformFailure({
  error,
  orderId,
  payload,
}: {
  error: unknown;
  orderId: string | null;
  payload: unknown;
}) {
  const exception =
    error instanceof Error ? error : new Error('Unknown error transforming order data');

  Sentry.withScope((scope) => {
    scope.setTag('order_transform', 'transformToOrder');
    scope.setContext('order_transform', {
      orderId,
      payload: summarizePayload(payload),
    });
    Sentry.captureException(exception);
  });
}

export function orderSchemaValidationMessage(error: ZodError) {
  return (
    error.issues
      .map((issue) => `${issue.path.join('.')}: ${issue.message}`)
      .slice(0, 3)
      .join('; ') || error.message
  );
}

export function reportOrderSchemaValidationFailure({
  error,
  orderId,
}: {
  error: ZodError;
  orderId: string | null;
}) {
  Sentry.withScope((scope) => {
    scope.setContext('zod_validation', {
      orderId,
      issues: error.issues.slice(0, 10).map((issue) => ({
        path: issue.path.join('.'),
        message: issue.message,
      })),
    });
    Sentry.captureException(error);
  });
}
